window.app = window.app || {};
app.ui = app.ui || {};


app.ui.tooltip = () => {
    document.querySelectorAll('.tooltip').forEach(tooltip => {
        tippy(tooltip, {
            content(reference) {
                return reference.querySelector('.tooltip-content').innerHTML;
            },
            maxWidth: 320,
            allowHTML: true
        });
    })
};
